const routes = [
    {
        path: '/monsters',
        component: () => import('@/pages/monster/MonsterHome.vue'),
        meta: { breadCrumb: 'Monster', entity: 'monster' },
        children: [
            {
                path: '',
                name: 'monster',
                component: () => import('@/pages/monster/MonsterList.vue'),
            },
            {
                path: 'monsterManual',
                name: 'monsterManual',
                component: () => import('@/pages/monster/MonsterManual.vue'),
            },
            {
                path: 'filter/:teamId?',
                name: 'filterMonster',
                component: () => import('@/pages/monster/MonsterList.vue'),
                props: true,
                meta: { breadCrumb: 'Filter' },
            },
            {
                path: 'new',
                name: 'newMonster',
                component: () => import('@/pages/monster/MonsterEditor.vue'),
                meta: { breadCrumb: 'New' },
            },
            {
                path: ':id/edit',
                name: 'editMonster',
                component: () => import('@/pages/monster/MonsterEditor.vue'),
                props: true,
                meta: { breadCrumb: 'Edit' },
            },
            {
                path: ':id/copy',
                name: 'copyMonster',
                component: () => import('@/pages/monster/MonsterEditor.vue'),
                props: route => ({ id: route.params.id, copy: true }),
                meta: { breadCrumb: 'Copy' },
            },
            {
                path: ':id/read/:tabName?',
                name: 'readMonster',
                component: () => import('@/pages/monster/MonsterReader.vue'),
                props: true,
                meta: { breadCrumb: 'Read' },
            },
            {
                path: 'archive',
                name: 'monsterArchive',
                component: () => import('@/pages/monster/MonsterArchive.vue'),
                meta: { breadCrumb: 'Archive' },
            },
        ],
    },
]

export default routes
